export const XS_BREAKPOINT = 0;
export const SM_BREAKPOINT = 600;
export const MD_BREAKPOINT = 960;
export const LG_BREAKPOINT = 1280;
export const XL_BREAKPOINT = 1920;
